var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77778 10.8V4.2H1.22222V10.8H9.77778ZM7.94444 0H9.16667V1.2H9.77778C10.1019 1.2 10.4128 1.32643 10.642 1.55147C10.8712 1.77652 11 2.08174 11 2.4V10.8C11 11.466 10.4561 12 9.77778 12H1.22222C0.898069 12 0.587192 11.8736 0.357981 11.6485C0.128769 11.4235 0 11.1183 0 10.8V2.4C0 1.734 0.543889 1.2 1.22222 1.2H1.83333V0H3.05556V1.2H7.94444V0ZM4.88889 5.1H6.11111V6.9H7.94444V8.1H6.11111V9.9H4.88889V8.1H3.05556V6.9H4.88889V5.1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.613e6027b8c950afd967eff197cb6e26.svg";
export { ForwardRef as ReactComponent };